import React from "react";
import Salutation from "../Salutation";
import About from "../About";
import Skills from "../Skills";
import Tecnologies from "../Tecnologies";
import Experience from "../Experience";

function Home() {
    return (
        <div className="App">
            <Salutation />
            <About />
            <Skills />
            <Tecnologies />
            <Experience />
        </div>
    );
}

export default Home;
